import React from "react";

export const IconWarning = ({ fill = "#1C2D3B", className = "", style = {} }) => {
  return (
    <svg className={`${className}`} style={style} fill="none" height="16" viewBox="0 0 16 16" width="16">
      <path
        className="path"
        d="M0 15H16L8 1L0 15ZM2.52364 13.5263L8 3.94L13.4764 13.5263C13.4764 13.5263 2.52364 13.5263 2.52364 13.5263ZM7.27273 11.3158H8.72727V12.7895H7.27273V11.3158ZM7.27273 6.89474H8.72727V10.4921H7.27273V6.89474V6.89474Z"
        fill={fill}
      />
    </svg>
  );
};
